import f1 from'../../../pip/library/pi-f1/pi-f1.js';

/**
 * this applies only to HIL for now
 */

export type TManifest = Record<string, unknown>;

export interface IPointCutRule {
  definition: IPointCut;
  match_by: {
    uri: string[];
  };
}

export interface IPointCut {
  /**
   * @note the old name was, `merge_onto`
   */
  merge_defaults: TManifest;
  /**
   * @note the old name was, `merge_over`
   */
  merge_overrides: TManifest;
}

export class PointCut {
  readonly lens = {
    matchByURI: f1.lens('/match_by/uri')
  };

  /**
   * location.hash.slice(1)
   */
  overlayPointCut<T extends TManifest>(pointCutRules: IPointCutRule[], uri: string, manifest: T): T {
    if (!f1.is.exists(pointCutRules)) {
      return manifest;
    } else if (f1.size(pointCutRules) <= 0) {
      return manifest;
    }

    const pointCuts: IPointCut[] = f1.reduce(
      (_pointCutDefinitions, rule: IPointCutRule) => {
        const uris: string[] = f1.read(this.lens.matchByURI, [], rule);
        const urisRegex: RegExp[] = f1.map((uri) => new RegExp(uri, 'i'), uris);

        const matchExists = uris && urisRegex.some((regex) => regex.test(uri) === true);
        if (matchExists) {
          _pointCutDefinitions.push(rule.definition);
        }

        return _pointCutDefinitions;
      },
      [] as IPointCut[],
      f1.safe([], pointCutRules)
    );

    const merge_defaults = f1.reduce(
      (_mergeOver, pointCut) => {
        return f1.merge('onto', _mergeOver, f1.safe({}, pointCut.merge_defaults));
      },
      {},
      pointCuts
    ) as TManifest;

    const merge_overrides = f1.reduce(
      (_mergeOver, pointCut) => {
        return f1.merge('onto', _mergeOver, f1.safe({}, pointCut.merge_overrides));
      },
      {},
      pointCuts
    ) as TManifest;

    return f1.merge('onto', f1.merge('onto', merge_defaults, f1.safe({}, manifest)), merge_overrides) as T;
  }
}
